import React from "react";
import { DocumentData, WithFieldValue } from "firebase/firestore";

import { DB_COLLECTION_NAMES } from "@constants";
import { useCreateDocument } from "../useCreateDocument";

function useCreateStep() {
  const { create } = useCreateDocument();

  const createStep = React.useCallback(
    function createStepCallback<T extends WithFieldValue<DocumentData>>(
      data: T,
    ) {
      return create(DB_COLLECTION_NAMES.STEPS, data);
    },
    [create],
  );

  return { createStep };
}

export { useCreateStep };
